import React, { useRef, useEffect, Fragment } from "react";
import clsx from "clsx";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../../../../../constant/TYPE";
import { setQuestionViewAction } from "../../../../../../../../redux/answeringQuestions/questionView";
import GrammarViewer from "../../../../../../../common/grammarViewer/GrammarViewer";
import Scribble from "./Scribble";

const Grammar = ( props ) => {

  const pvCont = useRef();

  const deviceInfo = useSelector( state => state.deviceInfo );
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const questionView = useSelector( state => state.questionView );

  const dispatch = useDispatch();
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };

  const pvInnerStyle = questionView.size.reduce( ( r, v, i ) => ( { ...r, [ i ? 'height' : 'width' ] : v || '' } ), {} );

  useEffect( () => {
    setQuestionView( { PV_CONT : pvCont.current } );
  }, [] );

  const { Scribbler } = props;

  return (
    <div className="mathExp-wrap">
      <div className="mathExp-inner">
        <div className={ clsx( 'mathExt', answeringQuestions.isShowKeypad && 'on', TYPE.DEVICE.PHONE === deviceInfo.type && 'add_pb' ) }>
          <div className="pvBox">
            <div className="pv-inner" style={ pvInnerStyle }>
              <div className="pv-cont" style={ { transform : `scale(${ questionView.scale })` } } ref={ pvCont }>
                <GrammarViewer name="question" type={ TYPE.MATHJAX.ANSWERING_QUESTIONS } onRender={ props.onRenderMathJax }>
                  { answeringQuestions.exercise.map( ( v, i, o ) => i + 1 === o.length ? v : `${ v }${ answeringQuestions.answer[ i ] }` ).join( '' ) }
                </GrammarViewer>
              </div>
            </div>
          </div>
          <Scribbler><Scribble /></Scribbler>
        </div>
      </div>
    </div>
  );

};

Grammar.defaultProps = {
  Scribbler : Fragment
};

export default Grammar;
